// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import Slider from 'fg-frontend/components/Slider';
import NumberInput from 'fg-frontend/src/components/NumberInput';
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
import ListToggle from 'fg-frontend/components/ListToggle';
import Typeahead from 'fg-frontend/components/Typeahead';
import FulltextAutocomplete from 'fg-frontend/components/FulltextAutocomplete';
import PasswordToggle from 'fg-frontend/components/PasswordToggle';
import SocialShare from 'fg-frontend/src/components/SocialShare';
import AnchorsList from 'fg-frontend/src/components/AnchorsList';
import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
import GreedyMenu from 'fg-frontend/components/GreedyMenu';
import ShareUrl from 'fg-frontend/src/components/ShareUrl';
import RedirectToUrl from 'fg-frontend/src/components/RedirectToUrl';
import Form from 'fg-frontend/src/components/Form';
import Webslider from 'fg-frontend/src/components/Webslider';

import SelectDesign from './components/SelectDesign';
import Tooltip from './components/Tooltip';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import LazyImage from './components/LazyImage';
import Countdown from './components/Countdown';
import Toggler from './components/Toggler';
// import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'RadioSelect':
    case 'CheckboxSelect':
      return RadioSelect;
    case 'SimpleCollapse':
      return SimpleCollapse;
    case 'GreedyMenu':
      return GreedyMenu;
    case 'Typeahead':
      return Typeahead;
    case 'SelectDesign':
      return SelectDesign;
    case 'ListToggle':
      return ListToggle;
    case 'PasswordToggle':
      return PasswordToggle;
    case 'SocialShare':
      return SocialShare;
    case 'AnchorsList':
      return AnchorsList;
    case 'FulltextAutocomplete':
      return FulltextAutocomplete;
    case 'Slider':
      return Slider;
    case 'RadioSelectTab':
      return RadioSelectTab;
    case 'NumberInput':
      return NumberInput;
    case 'UniversalPaginationButton':
      return UniversalPaginationButton;
    case 'Tooltip':
      return Tooltip;
    case 'GtmHandler':
      return GtmHandler;
    case 'TriggerInViewport':
      return TriggerInViewport;
    case 'ShareUrl':
      return ShareUrl;
    case 'RedirectToUrl':
      return RedirectToUrl;
    case 'Form':
      return Form;
    case 'LazyImage':
      return LazyImage;
    case 'Webslider':
      return Webslider;
    case 'Countdown':
      return Countdown;
    case 'Toggler':
      return Toggler;
    case 'GoogleRecaptcha':
      // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      }

      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js